import React from "react";
import Typist from "react-typist";
import "../../App";
import Seo from "../Seo";

const HowToPayHeader = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "How To Pay",
    url: "https://www.needforgeeks.com/how-to-pay",
    description:
      "Payment options for NeedForGeeks clients, including credit card, PayPal, Venmo, Zelle, cash, cheque, and crypto.",
  };

  const heroStyles = {
    container: {
      marginBottom: 0,
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      paddingTop: "100px",
      paddingBottom: "60px"
    },
    content: {
      maxWidth: "800px",
      margin: "0 auto",
      padding: "0 20px"
    },
    heading: {
      fontSize: "clamp(2rem, 6vw, 3.5rem)",
      fontWeight: "700",
      letterSpacing: "-0.02em",
      lineHeight: "1.2",
      marginBottom: "24px",
      textShadow: "0 4px 30px rgba(0, 0, 0, 0.3)"
    }
  };

  return (
    <div>
      <Seo
        title="How To Pay | NeedForGeeks"
        description="How to pay NeedForGeeks: we accept credit card, PayPal, Venmo, Zelle, cash, cheque, and crypto. Simple, flexible payment options for every client."
        path="/how-to-pay"
        structuredData={structuredData}
      />
      <div
        id="payHeader"
        className="jumbotron jumbotron-fluid bg-transparent bgstyle text-light"
        style={heroStyles.container}
      >
        <div style={heroStyles.content} className="container container-fluid text-center">
          <h1 style={heroStyles.heading}>How To Pay</h1>
          <Typist
            className="lead"
            cursor={{ show: true, blink: true, element: '|', hideWhenDone: true }}
            avgTypingDelay={30}
          >
            We accept various easy payment methods, as we always want to make things that much easier for our customers.
          </Typist>
        </div>
      </div>
    </div>
  );
};

export default HowToPayHeader;
